import Decimal from 'decimal.js';

const changeNumApi = {
  div18: (num) => {
    if (typeof num === 'number' || typeof num === 'string') {
      // Convert to string
      const numStr = num.toString();

      // Divide by 10^18 using decimal.js
      const decimalValue = new Decimal(numStr).dividedBy('1e18');
      return decimalValue.toString();
    }
    // Handle the case when num is not a valid number
    return 'Invalid Number';
  },

  div6: (num) => {
    if (typeof num === 'number' || typeof num === 'string') {
      // Convert to string
      const numStr = num.toString();

      // Divide by 10^6 using decimal.js
      const decimalValue = new Decimal(numStr).dividedBy('1e6');
      return decimalValue.toString();
    }
    // Handle the case when num is not a valid number
    return 'Invalid Number';
  },

  mul18: (num) => {
    if (typeof num === 'number' || typeof num === 'string') {
      // Convert to string
      const numStr = num.toString();

      // Multiply by 10^18 using decimal.js
      const decimalValue = new Decimal(numStr).times('1e18');
      return decimalValue.toString();
    }
    // Handle the case when num is not a valid number or string
    return 'Invalid Number';
  },

  // 숫자에 천단위 구분 쉼표를 추가하는 함수
  formatWithCommas: (num) => {
    if (typeof num !== 'number' && typeof num !== 'string') {
      return 'Invalid Number';
    }

    try {
      // 숫자를 Decimal 객체로 변환
      const decimalNum = new Decimal(num);

      // 정수부와 소수부 분리
      const parts = decimalNum.toString().split('.');

      // 정수부에 쉼표 추가
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 정수부와 소수부 다시 합치기 (소수부가 있는 경우에만)
      return parts.length === 2 ? parts.join('.') : parts[0];
    } catch {
      return 'Invalid Number';
    }
  },

  // div18 결과에 바로 쉼표를 추가하는 편의 함수
  div18WithCommas: (num) => {
    const divided = changeNumApi.div18(num);
    return divided === 'Invalid Number' ? divided : changeNumApi.formatWithCommas(divided);
  },

  // div6 결과에 바로 쉼표를 추가하는 편의 함수
  div6WithCommas: (num) => {
    const divided = changeNumApi.div6(num);
    return divided === 'Invalid Number' ? divided : changeNumApi.formatWithCommas(divided);
  }
};

export default changeNumApi;